module.exports = __webpack_public_path__ + "static/media/doc.146150e9.jpg";